module.exports = {"title":"Privacy Policy | Same Day Delivery","privacy_headline":"Privacy Policy","meta":{"description":"Privacy Policy"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/privacy/locale.json
// module id = 711
// module chunks = 0 1 2 3 4 5